import { Flexbox, Form } from '@/components'
import { ValidationForm } from '@/components/Form/styles'
import { Button } from '@/components/styles'
import yup from '@/lib/yupPt'
import mistreatmentTypes from '@/services/api/mistreatmentTypes'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { toast } from 'react-toastify'

const schema = yup.object().shape({
  title: yup.string().min(3).required().trim(),
  description: yup.string().min(3).required().trim(),
  active: yup.boolean(),
})

function FormMistreatmentType({ onSuccess, mistreatmentType, ButtonComponent }) {
  const [active, setActive] = useState(false)
  const [loading, setLoading] = useState(false)

  function close() {
    if (!loading) setActive(false)
  }

  async function onSubmit(values) {
    try {
      setLoading(true)
      let res
      if (mistreatmentType) {
        res = await mistreatmentTypes.update(mistreatmentType.id, values)
      } else {
        res = await mistreatmentTypes.create(values)
      }
      toast.success(`Tipo de denúncia ${mistreatmentType ? 'atualizado' : 'adicionado'} com sucesso`)
      onSuccess(res.data)
      close()
    } catch (e) {
      toast.error(e?.message || 'Ocorreu um erro ao salvar o tipo de denúncia')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <ButtonComponent onClick={() => setActive(true)} />
      {
        active && (
          <Form.Formik
            initialValues={{
              title: mistreatmentType ? mistreatmentType.title : '',
              description: mistreatmentType ? mistreatmentType.description : '',
              active: mistreatmentType ? mistreatmentType.active : true,
            }}
            validationSchema={schema}
            onSubmit={onSubmit}
            validateOnMount
          >
            {
              ({
                touched, errors, isValid, values,
              }) => (
                <fieldset disabled={loading}>
                  <ValidationForm>
                    <div className={`modal ${active ? 'active' : ''} text-left`}>
                      <a type="button" className="modal-overlay" aria-label="Close" onClick={close} />
                      <div className="modal-container">
                        <div className="modal-header">
                          <a
                            type="button"
                            className="btn btn-clear float-right"
                            onClick={close}
                          />
                          <div className="modal-title h5">
                            {mistreatmentType ? 'Editar tipo de denúncia' : 'Adicionar tipo de denúncia'}
                          </div>
                        </div>
                        <div className="modal-body">
                          <Flexbox.Columns>
                            <Flexbox.Column className="col-12">
                              <Form.Group className={`${touched?.title && errors?.title ? 'has-error' : ''}`}>
                                <Form.Label htmlFor="title">Título do tipo <span className="text-error">*</span></Form.Label>
                                <Form.ValidationField
                                  name="title"
                                  id="title"
                                  placeholder="Ex: Abandono de animal"
                                />
                                {
                                  touched?.title && errors?.title
                                    ? <Form.Hint className="text-error">{errors.title}</Form.Hint> : null
                                }
                              </Form.Group>
                            </Flexbox.Column>
                            <Flexbox.Column className="col-12">
                              <Form.Group className={`${touched?.description && errors?.description ? 'has-error' : ''}`}>
                                <Form.Label htmlFor="description">Adicione uma descrição <span className="text-error">*</span></Form.Label>
                                <Form.ValidationField
                                  name="description"
                                  id="description"
                                >
                                  {
                                    ({ field }) => (
                                      <TextareaAutosize
                                        name="description"
                                        style={{ resize: 'none' }}
                                        className="form-input"
                                        rows={1}
                                        maxRows={3}
                                        placeholder="Descreva o tipo de denúncia..."
                                        // eslint-disable-next-line react/jsx-props-no-spreading
                                        {...field}
                                      />
                                    )
                                  }
                                </Form.ValidationField>
                                {
                                  touched?.description && errors?.description
                                    ? <Form.Hint className="text-error">{errors.description}</Form.Hint> : null
                                }
                              </Form.Group>
                            </Flexbox.Column>
                            <Flexbox.Column className="col-12 pt-2 mt-2">
                              <Form.Group>
                                <Form.Switch className="form-switch" key={values?.active} style={{ marginTop: -8 }}>
                                  <Form.ValidationField
                                    type="checkbox"
                                    name="active"
                                    id="active"
                                    value={values?.active}
                                    checked={
                                      Boolean(values?.active)
                                    }
                                  />
                                  <i className="form-icon" />
                                  &nbsp;Ativo
                                </Form.Switch>

                              </Form.Group>
                            </Flexbox.Column>
                          </Flexbox.Columns>
                        </div>
                        <div className="modal-footer">
                          <Button
                            type="submit"
                            disabled={!isValid}
                            className={`btn-sm btn-primary ml-2 ${loading ? 'loading' : ''}`}
                          >
                            <i className="fas fa-paper-plane" />
                            &nbsp;Enviar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ValidationForm>
                </fieldset>
              )
            }
          </Form.Formik>
        )
      }
    </div>
  )
}

FormMistreatmentType.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  mistreatmentType: PropTypes.objectOf(Object),
  ButtonComponent: PropTypes.elementType.isRequired,
}

FormMistreatmentType.defaultProps = {
  mistreatmentType: null,
}

export default FormMistreatmentType
